import { render, staticRenderFns } from "./ongoing-delivery.vue?vue&type=template&id=3ace80e2"
import script from "./ongoing-delivery.vue?vue&type=script&lang=js"
export * from "./ongoing-delivery.vue?vue&type=script&lang=js"
import style0 from "./ongoing-delivery.vue?vue&type=style&index=0&id=3ace80e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports